<template>
	<div
		v-if="acceptPickUp"
		class="pick-up-time pickup"
		@click="showSchedule('Pickup')"
	>
		<div class="pick-up-time-status">
			<icon-svg
				class="pick-up-time-status-icon"
				:icon="pickUpStatus.icon"
				:height="16"
				:width="16"
				color="none"
			/>
		</div>
		<div class="pick-up-time-value">
			<div class="pick-up-time-value-name">
				Pickup
			</div>
			<div class="pick-up-time-value-separator" />
			<div class="pick-up-time-value-date">
				{{ pickUpStatus.time }}
			</div>
		</div>
	</div>
</template>

<script>
// Mixins
import availabilityTime from '@/mixins/availabilityTime'
import { getAmPmTime } from '@/utils/helpers'

export default {
	name: 'PickUpTime',

	mixins: [availabilityTime],

	computed: {
		isPickUpExist() {
			return this.pickUpHours && this.pickUpHours.length
		},

		startPickUp() {
			return this.isPickUpExist && this.pickUpHours[0].startTime
		},

		endPickUp() {
			return this.isPickUpExist && this.pickUpHours[0].endTime
		},

		pickUpStatus() {
			const endTime = getAmPmTime(this.endPickUp, 'h:mm a')?.toUpperCase() || ''
			const startTime =
				getAmPmTime(this.startPickUp, 'h:mm a')?.toUpperCase() || ''

			if (this.isPickUpOrderingAvailable) {
				return {
					icon: 'ic_available',
					time: `ends at ${endTime}`
				}
			}

			if (!this.isPickUpOrderingAvailable && this.isPickUpExist) {
				return {
					icon: 'ic_unavailable',
					time: `starts on ${this.getDayName(
						this.pickUpHours[0].dow
					)} ${startTime}`
				}
			}

			return {
				icon: 'ic_unavailable',
				time: 'Unavailable'
			}
		}
	}
}
</script>
